import React from 'react'

import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';

//status indicator
import u302 from '../../images/accounts/u302.png'
import u299 from '../../images/accounts/u299.png'
import u363 from '../../images/accounts/u363.png'


export default class TransactionCard extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={
            
        }
    }
    
    componentDidMount=()=>{
        
    }

    render(){
        const {status,action,type,date,provider,accNumber,service,amount} = this.props
        return <div ref={this.parentRef} style={{display:'flex',height:"7.7vh", width:'auto',flexDirection:'row', backgroundColor:Colors.white,overflowX:'hidden', border:'1px solid '+Colors.grey, margin:'1vw',borderRadius:5,borderLeft:status?'5px solid rgba(0,215,140,1)':'5px solid rgba(255,0,0,1)'}}>
            <div style={{display:'flex',flexDirection:'row', justifyContent:'space-evenly',alignItems:'center', flex:1}}>
                <div style={{display:'flex',width:'6.3vw', justifyContent:'space-between',alignItems:'center',}}>
                    <img alt='status' style={{height:'3.5vh'}} src={status?u302:u363}/>
                    {/* status */}
                    <div style={{display:'flex',border:status?'1px solid rgba(0,215,140,1)':'1px solid rgba(255,0,0,1)',borderRadius:5, padding:'.3vh', width:'3.5vw',height:'2vh', justifyContent:'center',alignItems:'center'}}><span style={{...Fonts.subtext,textAlign:'center',color:status?'rgba(0,215,140,1)':'rgba(255,0,0,1)'}}>{status?"Approved":"Dennied"}</span></div>
                </div>
                {/* Action */}
                <div style={{display:'flex',width:'3vw'}}><span style={{...Fonts.text}}>{action}</span></div>
                {/* transaction type */}
                <div><span style={{...Fonts.text}}>{type}</span></div>
                {/* Transaction Date */}
                <div><span style={{...Fonts.text}}>{date}</span></div>
                {/* Transaction Provider/account number, service */}
                <div style={{display:'flex',flexDirection:'column'}}>
                    <span style={{...Fonts.text}}>{provider}</span>
                    <span style={{...Fonts.text}}>{accNumber+' | '+service}</span>
                </div>
                {/* Transaction Amount */}
                <div><span style={{ ...Fonts.title, fontWeight:'bold'}}>{'$'+amount}</span></div>
                {/* dot dot dot */}
                <img alt='dotdotdot' style={{transform:'rotate(90deg)'}} src={u299}/>
            </div>
        </div>
    }
}